var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _polygon, _polygon2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCogecognextlogoMb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      height: 35,
      width: "auto"
    },
    viewBox: "0 0 150 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:url(#linear-gradient-5);}.cls-6{fill:url(#linear-gradient-6);}.cls-7{fill:url(#linear-gradient-7);}.cls-8{fill:url(#linear-gradient-8);}.cls-9{fill:url(#linear-gradient-9);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 2.88,
    y1: 27.72,
    x2: 151.08,
    y2: 27.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d398b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01aaec"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1.51,
    y1: 27.72,
    x2: 148.8,
    y2: 27.72,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -6.17,
    y1: 27.88,
    x2: 141.33,
    y2: 27.88,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -12.77,
    y1: 27.72,
    x2: 134.98,
    y2: 27.72,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -1.95,
    y1: 30.74,
    x2: 145.48,
    y2: 30.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -9.92,
    y1: 27.72,
    x2: 138.23,
    y2: 27.72,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -14.3,
    y1: 26.05,
    x2: 132.96,
    y2: 26.05,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 150.57,
    y1: -2472.86,
    x2: 138.41,
    y2: -2466.32,
    gradientTransform: "matrix(1.03, 0.01, 0.09, 1.08, 212.44, 2669.15)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcee21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#fce11c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#fbc00e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb9f00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -253.66,
    y1: 2107.75,
    x2: -250.23,
    y2: 2111.3,
    gradientTransform: "matrix(1.03, -0.01, 0.09, -1.08, 212.44, 2274.83)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fb9f00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#fccc13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcee21"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.88,27.68a9,9,0,0,1,.6-3.28,8.2,8.2,0,0,1,1.7-2.7,8.54,8.54,0,0,1,2.64-1.83,8.38,8.38,0,0,1,3.42-.67,8,8,0,0,1,4.24,1.08,7.13,7.13,0,0,1,2.69,2.92l-2.71.85a4.51,4.51,0,0,0-1.76-1.81A5.23,5.23,0,0,0,9,22.05,5,5,0,0,0,7.3,23.33a6,6,0,0,0-1.15,1.92,6.53,6.53,0,0,0-.43,2.43,6.67,6.67,0,0,0,.44,2.42,6.53,6.53,0,0,0,1.18,2,5.4,5.4,0,0,0,1.74,1.31,4.82,4.82,0,0,0,2.13.48,5,5,0,0,0,1.43-.21,5.76,5.76,0,0,0,1.29-.55,4.85,4.85,0,0,0,1-.81,2.78,2.78,0,0,0,.63-1l2.71.82a5.77,5.77,0,0,1-1.06,1.67,6.25,6.25,0,0,1-1.59,1.29,8.51,8.51,0,0,1-4.38,1.17,8.28,8.28,0,0,1-3.41-.69A8.08,8.08,0,0,1,5.22,33.7,8.38,8.38,0,0,1,3.5,31,8.91,8.91,0,0,1,2.88,27.68Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.85,36.25a8.15,8.15,0,0,1-3.39-.69,8,8,0,0,1-2.61-1.86A8.32,8.32,0,0,1,23.16,31a8.92,8.92,0,0,1-.6-3.25,8.77,8.77,0,0,1,.61-3.28,8.55,8.55,0,0,1,1.71-2.71,8,8,0,0,1,2.61-1.86,8.29,8.29,0,0,1,9.37,1.86,8.73,8.73,0,0,1,2.31,6,8.92,8.92,0,0,1-.6,3.25,8.14,8.14,0,0,1-7.72,5.26ZM25.4,27.77a6.73,6.73,0,0,0,.42,2.4A6.22,6.22,0,0,0,27,32.09a5.33,5.33,0,0,0,1.73,1.29,5,5,0,0,0,4.26,0,5.55,5.55,0,0,0,1.75-1.31,6,6,0,0,0,1.18-1.95,6.83,6.83,0,0,0,.43-2.41,6.7,6.7,0,0,0-.43-2.38,6.14,6.14,0,0,0-1.18-2A5.67,5.67,0,0,0,33,22.07a4.92,4.92,0,0,0-4.26,0A5.73,5.73,0,0,0,27,23.4a6.3,6.3,0,0,0-1.17,2A6.82,6.82,0,0,0,25.4,27.77Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M78.64,36.25H75.86v-9.2a7.15,7.15,0,0,0-.8-3.85A2.74,2.74,0,0,0,72.62,22a4.72,4.72,0,0,0-1.71.33,6.68,6.68,0,0,0-1.6.9A6.13,6.13,0,0,0,68,24.59a5.7,5.7,0,0,0-.85,1.73v9.93H64.36V19.8h2.52v3.53a7.25,7.25,0,0,1,2.82-2.78,8.08,8.08,0,0,1,4-1,4.79,4.79,0,0,1,2.36.52,4.07,4.07,0,0,1,1.52,1.45,6.46,6.46,0,0,1,.8,2.19,14.74,14.74,0,0,1,.24,2.75Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M107,19.5l4.51,6.05.28.35.26-.35,4.47-6.05h2.94l-6.15,8.26L119.5,36h-2.93l-4.51-6-.28-.36-.26.36L107,36h-2.93l6.18-8.19-6.15-8.26Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M57.45,19.48v3.28a9.27,9.27,0,0,0-2.56-2.55,6.25,6.25,0,0,0-3.59-1,7.12,7.12,0,0,0-3.11.67,7.65,7.65,0,0,0-2.41,1.85,8.43,8.43,0,0,0-1.56,2.73,9.71,9.71,0,0,0-.55,3.29,9.08,9.08,0,0,0,.55,3.15,8.62,8.62,0,0,0,1.56,2.68,7.68,7.68,0,0,0,2.41,1.86,6.89,6.89,0,0,0,3.08.69A6.73,6.73,0,0,0,53,35.9a6.44,6.44,0,0,0,1.61-.64,7.37,7.37,0,0,0,1.4-1,7,7,0,0,0,1.12-1.37v2.9A5,5,0,0,1,56.67,38a4.45,4.45,0,0,1-1.21,1.58,3.16,3.16,0,0,1-1.83.58,11.17,11.17,0,0,1-2.09,0,7.43,7.43,0,0,1-2.94-.75c-.16-.07-.63-.32-.79-.41l-.07,2.15a12.75,12.75,0,0,0,4,1.1,13.12,13.12,0,0,0,3.22-.12,5.13,5.13,0,0,0,2.52-1,6.72,6.72,0,0,0,1.79-2.26,6.8,6.8,0,0,0,.67-3.1V19.48Zm-.32,10.69a3.59,3.59,0,0,1-.63,1.35,5.19,5.19,0,0,1-1.16,1.18,6.27,6.27,0,0,1-1.52.84,4.67,4.67,0,0,1-1.7.32,5.15,5.15,0,0,1-2.22-.49,5.83,5.83,0,0,1-1.78-1.31,6.27,6.27,0,0,1-1.64-4.26,7,7,0,0,1,.37-2.25,6.65,6.65,0,0,1,1.08-2,5.35,5.35,0,0,1,1.68-1.42,4.69,4.69,0,0,1,2.26-.54,4.86,4.86,0,0,1,1.62.29,5.42,5.42,0,0,1,1.5.8,6.76,6.76,0,0,1,1.24,1.21,6.28,6.28,0,0,1,.9,1.55Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M99.13,24.41a8,8,0,0,0-7.65-5.21,8.39,8.39,0,0,0-3.4.67,8.29,8.29,0,0,0-4.4,4.56,8.77,8.77,0,0,0-.61,3.28A8.9,8.9,0,0,0,83.68,31a8.38,8.38,0,0,0,1.72,2.73,8,8,0,0,0,2.65,1.84,8.23,8.23,0,0,0,3.4.68,12.22,12.22,0,0,0,2.49-.16,8.64,8.64,0,0,0,2.08-.7,5.71,5.71,0,0,0,1.82-1.2c.15-.16.47-.44.6-.61l-1.54-1.4a6.75,6.75,0,0,1-2.18,1.54,9.74,9.74,0,0,1-1.63.28,7,7,0,0,1-1.52,0,5.65,5.65,0,0,1-2-.38,5.31,5.31,0,0,1-1.69-1.06,5.66,5.66,0,0,1-1.3-1.71A6.21,6.21,0,0,1,86,28.65H99.65c0-.1,0-.25,0-.44s0-.4,0-.63A8.81,8.81,0,0,0,99.13,24.41ZM85.94,26.6a6,6,0,0,1,.55-2.14,5.53,5.53,0,0,1,1.2-1.69,5.29,5.29,0,0,1,1.71-1.1,5.74,5.74,0,0,1,4.16,0,5.37,5.37,0,0,1,1.72,1.09,5.46,5.46,0,0,1,1.23,1.69,6,6,0,0,1,.59,2.15Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M132.66,21.75V19.57H129V15.84H126.2v3.73H124v2.18h2.24V32.81a3.06,3.06,0,0,0,1.1,2.61,4.25,4.25,0,0,0,2.62.83,7.5,7.5,0,0,0,1.27-.11,6.92,6.92,0,0,0,1.11-.28V33.44a4,4,0,0,1-1.47.26,2,2,0,0,1-1.26-.41A1.73,1.73,0,0,1,129,32V21.75Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "144.9 9.11 135.99 15.2 135.99 18.62 147.41 10.81 144.9 9.11"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "144.86 12.55 135.99 6.42 135.99 3 147.41 10.81 144.86 12.55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCogecognextlogoMb);
export default __webpack_public_path__ + "static/media/cogecognextlogo-mb.0b531a00f735c3e871881dc38b013153.svg";
export { ForwardRef as ReactComponent };